module.exports = __webpack_public_path__ + "img/calapan-reading-area.0ba8233b.jpg";